const SvgApply = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="39" height="48" fill="none"><rect width="37.98" height="47.474" x=".535" fill="#3FC092" rx="6.905"/>
            <path fill="url(#a)" fillRule="evenodd" d="M19.094 32.729a8.991 8.991 0 1 0 0-17.983 8.991 8.991 0 0 0 0 17.983Zm4.232-10.154a.9.9 0 0 0-1.271-1.272l-3.86 3.86-1.163-1.162a.9.9 0 0 0-1.271 1.271l1.798 1.799a.9.9 0 0 0 1.271 0l4.496-4.496Z" clipRule="evenodd"/><defs><linearGradient id="a" x1="10.102" x2="28.085" y1="14.746" y2="32.729" gradientUnits="userSpaceOnUse">
            <stop offset=".115" stopColor="#fff"/><stop offset="1" stopColor="#fff" stopOpacity=".5"/></linearGradient></defs></svg>
    )
}

export default SvgApply;